import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import Navbar from "../components/Navbar";
import { useLanguage } from "../contexts/LanguageContext";
import { ArrowLeft } from "lucide-react";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const BlogDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { lang } = useLanguage();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_URL}/api/articles/${slug}`)
      .then(r => setArticle(r.data))
      .catch(() => setArticle(null))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="animate-spin w-10 h-10 border-4 border-[#0596DE] border-t-transparent rounded-full" />
    </div>
  );

  if (!article) return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Navbar />
      <div className="max-w-2xl mx-auto px-4 py-16 text-center">
        <h1 className="text-2xl font-bold mb-4">Article introuvable</h1>
        <button onClick={() => navigate("/blog")} className="text-[#0596DE] underline">Retour au blog</button>
      </div>
    </div>
  );

  const title = lang === "ar" && article.title_ar ? article.title_ar : article.title;
  const content = lang === "ar" && article.content_ar ? article.content_ar : article.content;
  const excerpt = lang === "ar" && article.excerpt_ar ? article.excerpt_ar : article.excerpt;

  const renderContent = (text) => {
    return text.split("\n").map((line, i) => {
      if (line.startsWith("## ")) return <h2 key={i} className="text-xl font-bold text-[#0F172A] mt-6 mb-3">{line.replace("## ", "")}</h2>;
      if (line.startsWith("# ")) return <h1 key={i} className="text-2xl font-bold text-[#0F172A] mt-6 mb-3">{line.replace("# ", "")}</h1>;
      if (line.trim() === "") return <br key={i} />;
      return <p key={i} className="text-[#334155] leading-relaxed mb-3">{line}</p>;
    });
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC]" dir={lang === "ar" ? "rtl" : "ltr"}>
      <Helmet>
        <title>{title} | Tabbibak.com</title>
        <meta name="description" content={excerpt} />
      </Helmet>
      <Navbar />
      <article className="max-w-3xl mx-auto px-4 py-10">
        <button onClick={() => navigate("/blog")}
          className="flex items-center gap-2 text-[#0596DE] hover:underline mb-6 text-sm">
          <ArrowLeft className="w-4 h-4" /> Retour au blog
        </button>

        {article.cover_url && (
          <img src={article.cover_url} alt={title}
            className="w-full h-64 object-cover rounded-2xl mb-8" />
        )}

        <div className="flex flex-wrap gap-2 mb-4">
          {(article.tags || []).map(tag => (
            <span key={tag} className="bg-[#EFF6FF] text-[#0596DE] text-xs px-3 py-1 rounded-full">{tag}</span>
          ))}
        </div>

        <h1 className="text-3xl font-bold text-[#0F172A] mb-4">{title}</h1>
        <p className="text-[#64748B] text-sm mb-8">
          {article.clinic_name} · {new Date(article.created_at).toLocaleDateString("fr-DZ")}
        </p>

        <div className="prose max-w-none">
          {renderContent(content)}
        </div>

        <div className="mt-10 p-6 bg-[#EFF6FF] rounded-2xl text-center">
          <h3 className="font-bold text-[#0F172A] mb-2">Prenez rendez-vous avec un médecin</h3>
          <p className="text-[#64748B] text-sm mb-4">Tabbibak.com — Plateforme N°1 de RDV médical en Algérie</p>
          <a href="/search" className="bg-[#0596DE] text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-[#0369A1] transition-colors">
            Trouver un médecin
          </a>
        </div>
      </article>
    </div>
  );
};

export default BlogDetail;
